export default __webpack_public_path__ + "static/blog-02-900x678-5f25d2d45e22605b65e6413aa0c5f2bd.jpg";